import AppBackground from './app-background';

export default AppBackground;
